import { ALL_PERMISSION_PAGES, checkIsAPINew } from "../Config";
import Constants from "../data/constants";

class PermissionManager {

    //Permission Keys
    static PERMISSION_KEY_BRAND = Constants.BRAND_PAGE;
    static PERMISSION_KEY_BRANCH = Constants.BRANCH_PAGE;
    static PERMISSION_KEY_DASHBOARD = Constants.DASHBOARD_PAGE;
    static PERMISSION_KEY_SCREEN = Constants.SCREEN_PAGE;
    static PERMISSION_KEY_CAMPAIGN = Constants.CAMPAIGN_PAGE;
    static PERMISSION_KEY_PLAYLIST = Constants.PLAYLIST_PAGE;
    static PERMISSION_KEY_BRAND_MEDIA = Constants.BRAND_MEDIA_PAGE;
    static PERMISSION_KEY_BRAND_MEDIA_TRASH = Constants.BRAND_MEDIA_TRASH_PAGE;
    static PERMISSION_KEY_BRAND_PLAYLIST = Constants.BRAND_PLAYLIST_PAGE;
    static PERMISSION_KEY_MEDIA = Constants.MEDIA_PAGE;
    static PERMISSION_KEY_MEDIA_TRASH = Constants.MEDIA_TRASH_PAGE;
    static PERMISSION_KEY_USER = Constants.USER_PAGE;
    static PERMISSION_KEY_PUBLISH = "publish";
    static PERMISSION_KEY_WIDGET = Constants.WIDGET_PAGE;
    static PERMISSION_KEY_EVENT = Constants.EVENT_PAGE;
    static PERMISSION_KEY_ASSIGNSCREEN = "assignscreen";
    static PERMISSION_KEY_ROLE = "role";

    //Permission Types
    static PERMISSION_TYPE_LIST = "canRead";
    static PERMISSION_TYPE_CREATE = "canCreate";
    static PERMISSION_TYPE_EDIT = "canUpdate";
    static PERMISSION_TYPE_DELETE = "canDelete";
    static PERMISSION_TYPE_PUBLISH = "canPublish";
    static PERMISSION_TYPE_UPLOAD = "canUpload";

    //Old Permission Types
    // static PERMISSION_TYPE_LIST = 0;
    // static PERMISSION_TYPE_CREATE = 1;
    // static PERMISSION_TYPE_EDIT = 2;
    // static PERMISSION_TYPE_DELETE = 3;

    static userData;

    static currentBrandData = null;

    // Use new action keys
    static actionKeys = [
        "canRead",
        "canCreate",
        "canUpdate",
        "canDelete",
        "canPublish",
        "canUpload"
    ];

    static initPermissionConstants = () => {

        console.log("Initializing Permission Constants. checkIsAPINew " + checkIsAPINew())
        if (!checkIsAPINew()) {
            PermissionManager.PERMISSION_TYPE_LIST = 0;
            PermissionManager.PERMISSION_TYPE_CREATE = 1;
            PermissionManager.PERMISSION_TYPE_EDIT = 2;
            PermissionManager.PERMISSION_TYPE_DELETE = 3;
        }
    }


    static getAllPermiossionsInactive = () => {
        return ALL_PERMISSION_PAGES.map((page) => {
            const base = { id: page, name: page };
            PermissionManager.actionKeys.map((action) => {
                base[action] = undefined;
            })
            return base;
        });
    }

    static checkPermission = (key, permissionType = PermissionManager.PERMISSION_TYPE_LIST) => {

        var result = checkIsAPINew() ? PermissionManager.checkPermission_new(key, permissionType) : PermissionManager.checkPermission_old(key, permissionType);

        console.log("checkIsAPINew " + checkIsAPINew())
        console.log("checkPermission", key, permissionType, result)
        return result;

    }

    static convertRoleToSubmittable = (role) => {
        const result = {
            userroleid: role.id,
            userrolename: role.name,
            userrolepermission: {}
        };

        // const filteredPermissions = role.permissions.filter(perm => {

        // });
        for (const perm of role.permissions) {
            const permKey = perm.id || perm.name;
            result.userrolepermission[permKey] = {
                canCreate: !!perm.canCreate,
                canRead: !!perm.canRead,
                canUpdate: !!perm.canUpdate,
                canDelete: !!perm.canDelete,
                canPublish: !!perm.canPublish,
                canUpload: !!perm.canUpload
            };
        }

        return result;
    }

    //old version
    static checkPermission_old = (key, permissionType = PermissionManager.PERMISSION_TYPE_LIST) => {

        if (!PermissionManager.userData)
            return false;

        if (!("user" in PermissionManager.userData))
            return false;


        const userOBJ = PermissionManager.userData.user;
        // console.log(JSON.stringify(userOBJ.permission))
        // console.log(JSON.stringify(key))

        if (!("permission" in userOBJ))
            return false;

        if (!(userOBJ.permission))
            return false;

        if (key === "widget")
            return true;

        if (!(key in userOBJ.permission))
            return false;

        const permission = `${userOBJ.permission[key]}`;

        // console.log(JSON.stringify(permission))
        if (permission === "1")
            return true;
        else if (permission === "0")
            return false;

        return permission.charAt(permissionType) === "1"
    }

    static checkPermission_new = (key, permissionType = PermissionManager.PERMISSION_TYPE_LIST) => {

        console.log("checkPermission_new called", key, permissionType)
        if (!PermissionManager.userData)
            return false;

        if (!("user" in PermissionManager.userData))
            return false;


        const userOBJ = PermissionManager.userData.user;

        console.log("userData " + JSON.stringify(PermissionManager.userData))
        console.log("userOBJ " + JSON.stringify(userOBJ))
        // console.log(JSON.stringify(userOBJ.permission))
        // console.log(JSON.stringify(key))

        if (!("permission" in userOBJ))
            return false;

        if (!(userOBJ.permission))
            return false;

        if (key === "widget")
            return true;

        var isBrandSelected = false;

        if (PermissionManager.currentBrandData)
            isBrandSelected = true;

        if (!isBrandSelected) {
            //no brand selected, check if user has access to all brands
            // const hasAllBrandAccess = userOBJ.permission.find((permissionElement) => {
            //     const { BrandID = [] } = permissionElement

            //     console.log("BrandID " + JSON.stringify(BrandID) + " vs all brands")
            //     return BrandID.length === 0
            // })

            // console.log("hasAllBrandAccess " + JSON.stringify(hasAllBrandAccess))
            // if (!hasAllBrandAccess) {

            //     if (userOBJ.permission.length === 0)
            //         return true;

            //     return false;
            // }
            if (userOBJ.permission.length === 0)
                return true;
            //if has all brand access, use that permission
            const hasAllBrandAccess = userOBJ.permission[0];
            console.log("Using all brand access permission")
            if (!(key in hasAllBrandAccess.Menus))
                return false;

            const permission = hasAllBrandAccess.Menus[key];

            console.log("permission " + JSON.stringify(permission), key)

            if (permissionType in permission) {
                if (permission[permissionType] === 1)
                    return true;
                else if (permission[permissionType] === 0)
                    return false;
            }

            return false
        }

        console.log("userOBJ" + JSON.stringify(userOBJ))

        const brandPermission = userOBJ.permission.find((permissionElement) => {
            const { BrandID = [] } = permissionElement

            console.log("BrandID " + JSON.stringify(BrandID) + " vs " + PermissionManager.currentBrandData.BrandID)
            return BrandID.map(bid => `${bid}`).includes(`${PermissionManager.currentBrandData.BrandID}`)
        })

        console.log("brandPermission " + JSON.stringify(brandPermission))
        if (!brandPermission) {

            if (userOBJ.permission.length === 0)
                return true;

             if (userOBJ.permission.length === 0)
                return true;
            //if has all brand access, use that permission
            const hasAllBrandAccess = userOBJ.permission[0];
            console.log("Using all brand access permission")
            if (!(key in hasAllBrandAccess.Menus))
                return false;

            const permission = hasAllBrandAccess.Menus[key];

            console.log("permission " + JSON.stringify(permission), key)

            if (permissionType in permission) {
                if (permission[permissionType] === 1)
                    return true;
                else if (permission[permissionType] === 0)
                    return false;
            }

            return false

        }



        console.log("checkPermission_new", key, permissionType)

        if (!(key in brandPermission.Menus))
            return false;

        const permission = brandPermission.Menus[key];

        console.log("permission " + JSON.stringify(permission), key)
        if (PermissionManager.currentBrandData)
            console.log("checkPermission " + key + " + " + PermissionManager.currentBrandData.BrandID)

        console.log(JSON.stringify(permission))
        if (permissionType in permission) {
            if (permission[permissionType] === 1)
                return true;
            else if (permission[permissionType] === 0)
                return false;
        }

        return false
    }
}

export default PermissionManager